import React from 'react';
import { JsonForms } from '@jsonforms/react';
import {
  materialRenderers,
  materialCells,
} from '@jsonforms/material-renderers';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { InputLabel, TextField, Box } from '@mui/material';


const CustomIntegerRenderer = (props) => {
  const { data, handleChange, path, schema, uischema, enabled, visible, errors } = props;

  // Если элемент невидим, не рендерим ничего
  if (!visible) return null;


 const handleChangeInput = (event) => {
    const value = event.target.value;

    // Разрешаем пустую строку для очистки поля
    if (value === '') {
      handleChange(path, undefined);
      return;
    }

    // Проверяем, является ли введённое значение числом
    if (!isNaN(value) && value !== '-') {
      // Разделяем строку на целую и дробную части
      const [integerPart, decimalPart] = value.split('.');
      let formattedValue = integerPart;
      
      // Преобразуем в число
      const numValue = Number(formattedValue);
      if (!isNaN(numValue)) {
        handleChange(path, numValue);
      }
    }
  };


  const handleWheel = (event) => {
    event.preventDefault();
    event.target.blur(); // Снимаем фокус, чтобы предотвратить изменение значения при прокрутке
  };

  // Получаем min, max и step из JSON Schema, если они заданы
  const min = schema.minimum !== undefined ? schema.minimum : undefined;
  const max = schema.maximum !== undefined ? schema.maximum : undefined;
  const step = schema.multipleOf !== undefined ? schema.multipleOf : undefined;

  const width = uischema.options?.width ? uischema.options.width : undefined

    // Форматируем отображаемое значение с нужным количеством знаков
  //const displayValue = data !== undefined ? Number(data).toFixed(decimalPlaces) : '';

  return (
    <TextField
      type="integer"
      value={data !== undefined ? data : ''}
      onChange={handleChangeInput}
      //onWheel={handleWheel} // Отключаем колесо мыши
      disabled={!enabled}
      error={!!errors}
      helperText={errors || ''}
      inputProps={{
        min,
        max,
        step,
        style: { MozAppearance: 'textfield' }, // Отключаем стрелочки в Firefox
      }}
      InputProps={{
        sx: {
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { display: 'none', }, // Отключаем стрелочки в Chrome/Safari
          'width': width
        },
      }}
      fullWidth
      variant="outlined"
    />
  );
};

// Оборачиваем рендерер с помощью withJsonFormsControlProps
const CustomIntegerControl = withJsonFormsControlProps(CustomIntegerRenderer);

export default CustomIntegerControl